import { axiosInstance, CustomResponseFormat } from "api/instance";
import { DataState } from "../recoil/onboardingDataAtom";

export const ONBOARDING_DOMAIN = "onboarding";

export const ONBOARDING_PAGE_SAVE_ENDPOINT = "page/save";
export const ONBOARDING_PAGE_DATA_SAVE_ENDPOINT = "page-data/save";
export const ONBOARDING_LAST_PAGE_LOAD_ENDPOINT = "page-last/load";
export const ONBOARDING_QA_DETAIL_ENDPOINT = "qa/detail";
export const ONBOARDING_DATA_SAVE_ENDPOINT = "data/save";

export interface OnboardingPageId {
  pageId?: string;
}

export interface OnboardingQADetailType {
  pageGoal2Answer?: string; // 자신있고 주체적인 삶, 일상의 작은 행복을 만끽하는 삶
  pageGoal3Answer?: string; // 외부 환경의 변화 (진학, 이직 등)
  pageGoal5Answer?: string; // 우울, 범불안
  motivation7Answer?: string; // 배우자/연인, 부모/자식
}

export const ONBOARDING_QA_DETAIL_DEFAULT: OnboardingQADetailType = {
  pageGoal2Answer: "평안하고 여유로운 마음을 가진 삶",
  pageGoal3Answer: "여러 외부적 요인",
  pageGoal5Answer: "부정적",
  motivation7Answer: "기타",
};

export interface OnboardingData {
  resultText?: string;
}

export const onboardingApi = {
  savePage: (pageId: string) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_PAGE_SAVE_ENDPOINT}`,
      { pageId: pageId }
    ),

  savePageData: (pageId: string, data: DataState) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_PAGE_DATA_SAVE_ENDPOINT}`,
      { pageId: pageId, data: JSON.stringify(data) }
    ),

  loadLastPage: () =>
    axiosInstance.get<CustomResponseFormat<OnboardingPageId>>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_LAST_PAGE_LOAD_ENDPOINT}`
    ),

  getQADetail: () =>
    axiosInstance.get<CustomResponseFormat<OnboardingQADetailType>>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_QA_DETAIL_ENDPOINT}`
    ),

  saveOnboardingData: (data: OnboardingData) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_DATA_SAVE_ENDPOINT}`,
      { resultText: data.resultText }
    ),
};
